import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import ResumeList from '../resumeList/ResumeList';
import ResumeDetails from '../resumeDetail/index';
import { ResumeProvider } from '../context/resumeContext';

function ResumeRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"HEREEEEEEE")

  return (
    <ResumeProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<ResumeList />} />      {/*  Matches `/resume` */}
       <Route path=":id" element={<ResumeDetails />} />  {/* Matches `/resume/:id` */}
      </Route>
    </Routes>
    </ResumeProvider>
  );
}

export default ResumeRouter;
